import { DSCVR_STATIC_ASSETS_CDN_URL } from '@/common';
import { useDialog } from '@/shared/model';
import { fetchMedia } from '@/shared/lib';
import DialogContent from '../components/DialogContent.vue';
import { ImageHeader } from '@/shared/ui/base-dialog';
import type { PortalView } from 'dfx/edge/edge.did';

export function useCreateRoomDialog(portalView: PortalView) {
  const { dialogDefaults, openConfiguredDialog, closeDialog } = useDialog();

  const openCreateRoomDialog = () => {
    openConfiguredDialog({
      content: {
        component: DialogContent,
        props: {
          portalView,
        },
        emits: {
          close: closeDialog,
        },
      },
      header: {
        component: ImageHeader,
        slots: {
          media: {
            template: `<div class="min-h-28 -mx-6 bg-cover bg-center" style="background-image: url('${fetchMedia(
              `${DSCVR_STATIC_ASSETS_CDN_URL}/live/live-banner.png`,
            )}')" />`,
          },
        },
        emits: {
          close: closeDialog,
        },
      },
      dialog: {
        contentClasses: `${dialogDefaults.dialog.contentClasses} max-w-screen-md overflow-hidden`,
      },
      drawer: {
        customClasses: dialogDefaults.drawer.customClasses,
      },
    });
  };

  return {
    openCreateRoomDialog,
    closeDialog,
  };
}
